import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import CheckIcon from '@mui/icons-material/Check'
import { __t } from '../../../../i18n/t'
import { OutlineButton, PrimaryButton, TextButton } from '../ui/controls'
import { C } from '../ui/tokens'

const rowSx = { display: 'flex', gap: 0.75, alignItems: 'center', justifyContent: 'flex-start' } as const
const rowSpreadSx = { display: 'flex', gap: 0.75, alignItems: 'center', justifyContent: 'space-between' } as const
// Valores de estilo com espaço (como '16px 28px') ficam em constante: o plugin de i18n embrulha literal com espaço dentro de ternário.
const PAD_NARROW = '16px'
const PAD_WIDE = '16px 28px'
const nextSx = { minHeight: 48, height: 'auto', py: 1, whiteSpace: 'normal', textAlign: 'center', lineHeight: 1.25, flex: { sm: '0 1 auto' } } as const

/**
 * Rodapé do cartão. Largo: Voltar e Cancelar à esquerda, o botão principal à direita. Estreito (celular): o principal em cima,
 * Voltar e Cancelar embaixo. A ordem no HTML é a mesma da tela nos dois casos, então a tecla Tab e o leitor de tela seguem o que se vê.
 */
export const Footer: React.FC<{
  narrow: boolean
  canBack: boolean
  onBack: () => void
  onCancel: () => void
  onNext: () => void
  nextLabel: string
  last: boolean
  saving: boolean
  disabled?: boolean
}> = ({ narrow, canBack, onBack, onCancel, onNext, nextLabel, last, saving, disabled }) => {
  const primary = (
    <PrimaryButton
      onClick={onNext}
      disabled={saving || disabled}
      busy={saving}
      icon={saving ? <CircularProgress size={18} color="inherit" /> : undefined}
      endIcon={saving ? undefined : last ? <CheckIcon /> : <ArrowForwardIcon />}
      sx={nextSx}
    >
      {nextLabel}
    </PrimaryButton>
  )
  const secondary = (
    <Box sx={narrow ? rowSpreadSx : rowSx}>
      {canBack ? <OutlineButton onClick={onBack} icon={<ArrowBackIcon />} sx={{ px: 2 }}>{__t('Voltar')}</OutlineButton> : null}
      <TextButton onClick={onCancel} disabled={saving} color={C.muted} sx={{ height: 44, fontSize: 15, px: 1.5 }}>{__t('Cancelar')}</TextButton>
    </Box>
  )
  return (
    <Box
      sx={{
        mt: 'auto', borderTop: `1px solid ${C.line}`, p: narrow ? PAD_NARROW : PAD_WIDE, bgcolor: '#fafbfd', borderRadius: '0 0 16px 16px',
        display: 'flex', flexWrap: 'wrap', flexDirection: narrow ? 'column' : 'row', justifyContent: 'space-between', alignItems: narrow ? 'stretch' : 'center', gap: 1.5,
      }}
    >
      {narrow ? primary : secondary}
      {narrow ? secondary : primary}
    </Box>
  )
}
